exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-creation-popup-header{\n  width: 100%;\n  background-color: #445271;\n  padding: 15px;\n  border-radius: 5px 5px 0 0;\n  color: white\n}\n\n.account-update-popup-fields{\n  padding: 10px;\n  height: 36px;\n  width: 230px;\n  margin-right: 20px;\n  border-radius: 4px;\n  border: solid 1px #d0d0d0;\n  background-color: #ffffff;\n}\n\n.some-margin-bottom{\n  margin-bottom: 20px;\n}\n\n.profile-submit-button{\n    margin-left: 30px;\n    height: 36px;\n    border-radius: 4px;\n    color: white;\n    background-image: linear-gradient(119deg, #476094, #3d4963);\n}\n", ""]);

// exports
